import type ODDS_FORMAT from '~/enums/odds_format';

export function getOddsByFormat(
	bet: {
		oddsAmerican: string;
		oddsDecimal: number;
		oddsFractional: string;
	},
	format: ODDS_FORMAT,
): string {
	switch (format) {
		case 'decimal':
			return bet.oddsDecimal.toFixed(2);
		case 'fractional':
			return bet.oddsFractional;
		default:
			return bet.oddsAmerican;
	}
}
